/**
 * 此处放置订单相关api
 */
import http from "@/assets/http.js";
import request from "@/assets/request.js";
export default {
    /**
     * 查询消息列表
     * @pageNum    当前页数
     * @pageSize   分页条数
     */
    queryNOticelist(data) {
        return http({
            url: "/api/shop-message/list",
            "Content-Type": "application/json;charset=utf-8",
            method: "post",
            data,
        });
    },

    /**
     *  删除店铺消息
     */
    deleteNotice(data) {
        return http({
            url: "/api/shop-message/remove",
            "Content-Type": "application/json;charset=utf-8",
            method: "post",
            data,
        });
    },
    /**
     *  已读店铺消息
     */
    updateNotice(data) {
        return http({
            url: "/api/shop-message/update",
            "Content-Type": "application/json;charset=utf-8",
            method: "post",
            data,
        });
    },
}

/**
 *  更新菜单已读未读数量
 */
export const unreadCount = ()=>{
   return http({
            url: "/api/shop-message/unread-count",
            "Content-Type": "application/json;charset=utf-8",
            method: "post"
        });
} 
